export { SearchPage } from "./SearchPage";
